module.exports = __webpack_public_path__ + "media/images/athletes/3323-ea728372136b786080235e3150917985.png";